var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08333 14C4.73958 14 4.44531 13.8741 4.20052 13.6223C3.95573 13.3705 3.83333 13.0679 3.83333 12.7143V4.14286H3V2.85714H6.33333V2H9.66667V2.85714H13V4.14286H12.1667V12.7066C12.1667 13.0689 12.0443 13.375 11.7995 13.625C11.5547 13.875 11.2604 14 10.9167 14H5.08333ZM10.9167 4.14286H5.08333V12.7143H10.9167V4.14286ZM6.33333 11.4286H7.58333V5.42857H6.33333V11.4286ZM8.41667 11.4286H9.66667V5.42857H8.41667V11.4286Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.a57e2cde87a10c6882d5aca32ccce834.svg";
export { ForwardRef as ReactComponent };